import axios from "axios";

export const getDepartment = async (lat: number, long: number) => {
  const res = await axios.get(
    `https://geo.api.gouv.fr/communes?lat=${lat}&lon=${long}&fields=departement&format=json`
  );

  return res.data.pop().departement.nom;
};
